var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0319 6.36044V4.46585C7.0319 3.94267 7.47495 3.51855 8.02148 3.51855H11.485C12.0316 3.51855 12.4746 3.94267 12.4746 4.46585V6.36044M4.06315 15.8334H15.9382C17.0312 15.8334 17.9173 14.9851 17.9173 13.9388V8.25502C17.9173 7.20867 17.0312 6.36044 15.9382 6.36044H4.06315C2.97009 6.36044 2.08398 7.20867 2.08398 8.25502V13.9388C2.08398 14.9851 2.97009 15.8334 4.06315 15.8334Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage04);
export default __webpack_public_path__ + "static/media/luggage-04.759d60d9b8a2bd223200d47ead00a1d6.svg";
export { ForwardRef as ReactComponent };